/* global attachEvent */
// *******************************************************************************
// File upload
// *******************************************************************************
// Ref - https://jsfiddle.net/alexjamesbrown/2nzL9f7g/

const filesToUpload = {};

const uploadBoxInput = document.querySelectorAll('.upload-box__input');

uploadBoxInput.forEach((inputEle, index) => {
  filesToUpload[index] = [];

  let nextFileID = 1;
  // const fileRemoved = new Event('fileRemoved');

  const fileUploader = (evt, files) => {
    const parentElem = evt.target.closest('.upload-box');
    const uploadBoxId = parentElem.getAttribute('data-upload-id');
    const filesArray = filesToUpload[uploadBoxId];
    const selectedList = parentElem.querySelector('.upload-box__list-text-wrapper');
    const selectedListParent = parentElem.querySelector('.upload-box__list');

    const descriptionInputPlaceholder = selectedListParent.getAttribute('data-description-input-placeholder');
    const authorInputPlaceholder = selectedListParent.getAttribute('data-author-input-placeholder');
    const descriptionInputErrorMsg = selectedListParent.getAttribute('data-description-input-error');
    const authorInputErrorMsg = selectedListParent.getAttribute('data-author-input-error');

    selectedListParent.classList.remove('hide');

    Array.from(files).forEach((file) => {
      const liElement = document.createElement('li');
      liElement.innerHTML = `
        <div class="upload-box__list-file">
          <div class='upload-box__list-text'>${file.name}</div>
          <button id=${nextFileID} type='button' class='upload-box__list-remove'>
            <i class="icon : icon-delete"></i>
          </button>
        </div>
        <div class="upload-box__list-input">
          ${
            descriptionInputPlaceholder
              ? `
                <div class="mod-input mod-input--textarea mod-input--secondary">
                  <div class="mod-input__inner">
                    <textarea
                      class="mod-input__field"
                      placeholder="${descriptionInputPlaceholder || 'Dodajte kratek opis fotografije ...'}"
                      id="${nextFileID}-photo-description-${index}"
                      name="${nextFileID}-photo-description-${index}"
                      autocomplete="off"
                      required
                      data-fv-not-empty___message="${descriptionInputErrorMsg || 'This field is required'}"
                      data-fv-name="${nextFileID}-photo-description-${index}"
                      data-max-size="${inputEle.dataset.maxSize}"
                      data-size-error="${inputEle.dataset.sizeError}"
                      data-type-error="${inputEle.dataset.typeError}"
                      data-extensions="${inputEle.dataset.extension}"
                    ></textarea>
                  </div>
                </div>
              `
              : ''
          }
          ${
            authorInputPlaceholder
              ? `
                <div class="mod-input mod-input--secondary">
                  <div class="mod-input__inner">
                    <input type="text" class="mod-input__field"
                            placeholder="${authorInputPlaceholder || 'Dodajte avtorja fotografije ..'}"
                            id="${nextFileID}-photo-author-${index}"
                            name="${nextFileID}-photo-author-${index}"
                            autocomplete="off"
                            data-fv-name="${nextFileID}-photo-author-${index}"
                            data-fv-not-empty___message="${authorInputErrorMsg || 'This field is required'}"
                            required
                            data-fv-name="${nextFileID}-photo-description-${index}"
                            data-max-size="${inputEle.dataset.maxSize}"
                            data-size-error="${inputEle.dataset.sizeError}"
                            data-type-error="${inputEle.dataset.typeError}"
                            data-extensions="${inputEle.dataset.extension}"
                    >
                    </input>
                  </div>
                </div>
              `
              : ''
          }
        </div>`;

      const ulElement = selectedList.querySelector('ul');
      liElement.setAttribute('data-upload-file', nextFileID);
      ulElement.appendChild(liElement);

      filesArray.push({ id: nextFileID, file });
      nextFileID += 1;
    });
  };

  inputEle.addEventListener('change', (evt) => {
    fileUploader(evt, evt.target.files);
  });

  // File drop
  const parentElem = inputEle.closest('.upload-box');
  const holder = parentElem.querySelector('.upload-box__inner');
  if (holder) {
    holder.ondragover = () => {
      parentElem.classList.add('is-hovered');
    };
    holder.ondragend = () => {
      parentElem.classList.remove('is-hovered');
    };
    holder.ondrop = (e) => {
      parentElem.classList.remove('is-hovered');
      inputEle.files = e.dataTransfer.files;
      parentElem.querySelector('.upload-box__input').dispatchEvent(new Event('change'));
      e.preventDefault();
    };
  }

  // *******************************************************************************
  // Remove uploaded files
  // *******************************************************************************

  attachEvent('.upload-box__list-remove', 'click', (el) => {
    const removeParentElem = el.target.closest('li');
    const uploadBoxId = parentElem.getAttribute('data-upload-id');
    const filesArray = filesToUpload[uploadBoxId];

    if (filesArray) {
      Array.from(filesArray).forEach((file, i) => {
        if (file && file.id === Number(el.target.id)) {
          filesArray.splice(i, 1);
        }
      });
    }

    // inputEle.dispatchEvent(fileRemoved);
    removeParentElem.remove();
  });
});
